import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { Observable, Subscription } from 'rxjs';
import { TypeAccesPersonneMoraleDto, TypeEvacuationDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-evacuation-select',
  templateUrl: './type-evacuation-select.component.html',
  styleUrls: ['./type-evacuation-select.component.css']
})
export class TypeEvacuationSelectComponent implements OnInit {

  @Select(ControlPanelStore.typesEvacuations$) typesEvacuations$: Observable<TypeEvacuationDto[]>;

  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dxDataGrid') dataGrid: DxDataGridComponent;

  @Input() disabled: boolean = false;
  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() typeEvacuationId: number;
  @Output() typeEvacuationIdChange = new EventEmitter<number>();

  @Input() cell: any;

  @Input() typesEvacuationInput = null;

  InitId = null;

  TypesEvacuations: TypeEvacuationDto[] = [];
  ColumnName = [];

  ta: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
      this.translate.get(
        [
          'Identifiant',
          'Reference'
        ]
        ).subscribe(translations => {
          this.ColumnName.push(translations['Identifiant']);
          this.ColumnName.push(translations['Reference']);
        });
    }

  ngOnInit() {
    if(this.typeEvacuationId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.typeEvacuationId));
    }
    this.ta = this.typesEvacuations$.subscribe(res => {
      if (res != null && this.typesEvacuationInput == null) {
        this.TypesEvacuations = res;
      }
    });

    if(this.typesEvacuationInput != null) {
      this.typesEvacuationInput.subscribe(res => {
        this.TypesEvacuations = res;
      });
    }
  }

  ngOnDestroy() {
    this.ta?.unsubscribe();
  }

  updateInfo(event) {
    this.typeEvacuationId = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.typeEvacuationId;
    if (!!this.cell && this.InitId != this.typeEvacuationId) {
      this.cell.setValue(this.typeEvacuationId);
    }
    this.typeEvacuationIdChange.emit(this.typeEvacuationId);

    if(this.typeEvacuationId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.typeEvacuationId == null) {
      this.dataGrid.instance.clearSelection();
    }
    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
